import React, { Component } from 'react';
import pdfIcon from '../assets/images/pdfIconPNG.png';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Global from '../Global';

const api = Global.api

class Tramites extends Component {
    state = {
        forms: [],
        formsAlumnos: [],
        formsDocentes: [],
        formsExternos: [],
        formsMostrados: [],
        status: null,
        listBuilded: false
    }

    listForm = null;
    formDetailsRender = null;

    componentWillMount() {
        this.getTramites();
    }

    getTramites = () => {
        axios.get(api + "/forms").then(res => {
            const forms = res.data.forms;
            let formsA = forms.filter((form) => {
                return form.form_type === 'alumnos'
            })
            let formsD = forms.filter((form) => {
                return form.form_type === 'docentes'
            })
            let formsE = forms.filter((form) => {
                return form.form_type === 'externos'
            })
            this.setState({
                forms: forms,
                status: res.status,
                formsAlumnos: formsA,
                formsDocentes: formsD,
                formsExternos: formsE,
                formsMostrados: forms
            });

            this.renderFormsList(formsA);
        });
    }

    changeSolicitante = (e) => {
        switch (e.target.value) {
            case 'alumno': {
                this.renderFormsList(this.state.formsAlumnos);
                break;
            }
            case 'docente': {
                this.renderFormsList(this.state.formsDocentes);
                break;
            }
            case 'externo': {
                this.renderFormsList(this.state.formsExternos);
                break;
            }
            default: {
                this.renderFormsList(this.state.formsAlumnos);
                break;
            }
        }
    }

    renderFormsList = (forms) => {
        this.listForm = forms.map((form) => {
            return (
                <span key={form._id} className="menu-item" onClick={() => this.buildFormDetails(form)}>{form.form_name}</span>
            );
        });
        //this.buildFormDetails(forms[0]);
        this.setState({
            listBuilded: true
        });
    }

    buildFormDetails = (form) => {
        const docsAnnexList = form.form_annex[0] !== 'Sin Documento Anexado' ? form.form_annex.map((doc) => {
            return (
                <a key={doc.split('__')[1]} href={api + '/' + doc} donwload={doc.split('__')[1]} className="doc-image" target="blank">
                    <img src={pdfIcon} alt='ícono de PDF' />
                    <p>{doc.split('__')[1]}</p>
                </a>
            )
        }) : (<span><b> • </b>Sin documentos adjuntos<br /></span>);

        const requiredDocsList = form.form_doc.map((doc) => {
            return (
                <span key={doc.title}><b> • </b>{doc.title} <br /></span>
            )
        })

        const form_desc_parts = form.form_desc.split(':');
        let form_desc = form.form_desc;
        if (form_desc_parts.length > 2) {
            form_desc = (
                <>
                    <>{form_desc_parts[0] + ": "}</>
                    <a href={form_desc_parts[1] + ':' + form_desc_parts[2]} target="_blank" rel="noreferrer">solicitud</a>
                </>
            )
        }

        this.formDetailsRender = (
            <>
                <h4 id="tramite_name">{form.form_name}</h4>
                <hr />
                <h5>Descripción</h5>
                <p id="tramite_description">
                    {form_desc}
                </p>
                <br />
                <h5>Documentos requeridos</h5>
                <div>{requiredDocsList}</div>
                <br />
                <hr></hr>
                <div className="documents-container">
                    <div className="docs-guia-container">
                        <h5>Documentos adjuntos</h5>
                        <div className="docs-image-container">
                            {docsAnnexList}
                        </div>
                    </div>
                </div>
                <br></br>
                <div className="button-container">
                    <Link to={"/solicitud/" + form._id} className="btn btn-warning realizar-solicitud">Realizar solicitud</Link>
                </div>
            </>
        )
        this.setState({
            listBuilded: true
        });
    }

    render() {
        if (this.state.listBuilded) {
            return (
                <div>
                    <div className="solicitudes_container">
                        <div className="row">
                            <div className="col-lg-1 col-md-1"></div>
                            <div className="col-lg-10 col-md-10 col-sm-12">
                                <div className="row">
                                    <div className="col-12">
                                        <span className="breadcrumbs"><a href="/solicitudes">Inicio </a> / <a href="/solicitudes/tramites"> Tramites</a></span>
                                    </div>
                                    <div className="col-12">
                                        <br />
                                        <h1>Trámites disponibles</h1>
                                    </div>
                                    <div className="col-12">
                                        <div className="row align_left_row">
                                            <div className="select_solicitante_left">
                                                <label>Selecciona el tipo de trámite:</label>
                                            </div>
                                            <div className="col-sm-2 col-6 select_solicitante_right">
                                                <select onChange={this.changeSolicitante} className="form-control" id="select_tipo_solicitante" defaultValue='alumno'>
                                                    {(this.state.formsAlumnos.length > 0) && <option value="alumno">Alumno</option>}
                                                    {(this.state.formsDocentes.length > 0) && <option value="docente">Docente</option>}
                                                    {(this.state.formsExternos.length > 0) && <option value="externo">Externo</option>}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <br />
                                        <div className="row tramites-header">
                                            <div className="col-lg-3 col-md-5">
                                                <h3>Trámites</h3>
                                            </div>
                                            <div className="col-lg-9 col-md-7">
                                                <h3>Descripción</h3>
                                            </div>
                                        </div>
                                        <div className="row tramites-container">
                                            <div className="col-lg-3 col-md-5 tramites-menu">
                                                {this.listForm}
                                            </div>
                                            <div className="col-lg-9 col-md-7 tramites-description">
                                                <br/>
                                                {this.formDetailsRender || <><h6 style={{textAlign: 'center'}}>Selecciona un trámite para comenzar</h6></>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1 col-md-1"></div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <h4>Cargando ...</h4>
            );
        }
    }
}

export default Tramites;